import { Grid } from '@mui/material';
import { DateUrlParamsFilter } from '../../entities/filters/date-url-params-filter';
import { useOurCompany } from '../../hooks/portal-settings.hook';
import { LegalEntityParamFilter } from '../../entities/legal-entities/legal-entity-param-filter';
import { FilterCard } from '../../components/Mui/filter-card';
import { ManagerUrlParamsFilter } from 'entities/filters/manager-url-params-filter';

export const WccFileFilter = () => {
  const ourCompanyId = useOurCompany();

  return (
    <FilterCard>
      <Grid
        container
        spacing={2}
        sx={{
          display: 'flex',
          flexDirection: 'row'
        }}
      >
        <Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
          <LegalEntityParamFilter queryParamName={'ourLegalEntityId'} label="Наше юрлицо" companyId={ourCompanyId} />
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
          <ManagerUrlParamsFilter queryParamName='uploadedById'/>
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={2} xl={2}>
          <DateUrlParamsFilter queryParamName={'createdAt'} label="Дата создания с" />
        </Grid>
      </Grid>
    </FilterCard>
  );
};
